export default {
  offline: 'There is no internet connection.',
  multiple_title: 'It looks like you have multiple pages open',
  multiple_tabs: 'We do not currently support working across multiple tabs to work on more than one of your pages at once. Therefore please reload or close this tab to continue.'
}